export default __webpack_public_path__ + "static/media/djirra.c8e716ce.png";